import { NgModule } from '@angular/core';
import { FullAddressDirective } from './full-address.directive';
import { ResizableDrawerDirective } from './resizable.directive';


@NgModule({
  imports: [ResizableDrawerDirective],
  declarations: [FullAddressDirective],
  exports: [FullAddressDirective, ResizableDrawerDirective]
})
export class DirectivesModule { }
